import { Container, Stack, Heading } from '@chakra-ui/react'

import { FeaturesItem } from '../../../../Components/Features'

import Feature1 from '../../../../Assets/feature_1.svg'
import Feature2 from '../../../../Assets/feature_2.svg'
import Feature3 from '../../../../Assets/feature_3.svg'

import CustomHighlight from '../../../../Components/Elements/CustomHighlight'

const Features = () => {
    return (
        <Container
            maxW={'4xl'}
            py={10}
        >
            <Stack textAlign={'center'} pb={10}>
                <Heading fontWeight={700} fontSize={'4xl'}>
                    <CustomHighlight query={['Scholarships']}>Scholarships</CustomHighlight>
                </Heading>
            </Stack>
            <Stack direction={'column'} spacing={16}>
                <FeaturesItem
                    heading={'Comprehensive Scholarship Database'}
                    text={'Our website offers access to hundreds of regularly updated scholarships that can be searched by field of study, demographic, and more.'}
                    image={Feature1}
                    reverse={false}
                />
                <FeaturesItem
                    heading={'Up-to-Date Opportunities'}
                    text={'Our team constantly updates our database to ensure that all scholarships listed on our website are current and still accepting applications.'}
                    image={Feature2}
                    reverse={true}
                />
                <FeaturesItem
                    heading={'Free to Use for All'}
                    text={'Our platform is accessible to everyone at no cost, allowing you to search and apply for scholarships without any financial obligation.'}
                    image={Feature3}
                    reverse={false}
                />
            </Stack>
        </Container>
    )
}

export default Features